export default __webpack_public_path__ + "static/media/udp1.50f22919.png";